import React, { useEffect, useState } from "react";
import { getMatchPhase } from "../../utility/activeBetMatchMarkets";

const PHASE_LABEL = {
  upcoming: "Upcoming",
  live: "Live",
  ended: "Ended",
};

/** Badge only — same phase rules as the TV box / backend isGameLive. */
const MatchStatus = ({ matchTime, game }) => {
    const [status, setStatus] = useState("");

    useEffect(() => {
        const refresh = () => {
            const phase = getMatchPhase(matchTime, game);
            setStatus(PHASE_LABEL[phase] || "Upcoming");
        };

        refresh();
        const interval = setInterval(refresh, 60000);
        return () => clearInterval(interval);
    }, [matchTime, game]);

    return (
        <div>
            <span className="liveBtn">{status}</span>
        </div>
    );
};

export default MatchStatus;
